"use strict";

$(".button--cookie").click(function () {
  $("#cookie--banner").hide();
});

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}
if (getCookie('cookies-accepted') == 'yes') {} else {
  setTimeout(function () {
    if (parseInt(getCookie('visited')) >= 2) {
      $("#cookie--banner").addClass("apparition--cookie");
      var CookieDate = new Date();
      CookieDate.setMonth(CookieDate.getMonth() + 12);
      document.cookie = "cookies-accepted=yes; expires=" + CookieDate.toGMTString() + "; path=/";
    }
  }, 3000);
}
'use strict';

$('.faq__q__and__a').on('click', function () {
  var $question = $(this).children('.faq__question');
  if ($question.siblings().attr('aria-hidden') == 'false') {
    $question.siblings().slideToggle(200).attr('aria-hidden', 'true');
    $question.children('span').attr('arrow-open', 'false');
  } else {
    $('.faq__q__and__a').find('.faq__answer[aria-hidden="false"]').not($question).slideToggle(200).attr('aria-hidden', 'true');
    $('.faq__q__and__a').find('.arrow[arrow-open="true"]').attr('arrow-open', 'false');
    $question.siblings().slideToggle(200).attr('aria-hidden', 'false');
    $question.children('span').attr('arrow-open', 'true');
  }
});

$('.sidebar__sections--list-link').on('click', function () {
  var id = $(this).attr('section-id');
  console.log($(id).offset().top);

  $('html, body').animate({
    scrollTop: $(id).offset().top - 70
  }, 500);
});
'use strict';

// Filters
$('body').on('click', '.reinitialize__filters', function () {
  window.collection.currentFilters = [];
  $('.reinitialize__filters').hide();
  $('.filter__item--mini').remove();
  $('.filter__button').removeClass('is__active');
  var filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + '?sort_by=' + window.collection.sortBy;
  if (history.replaceState) {
    window.history.pushState({ path: filteredUrl }, '', filteredUrl);
  }
  $.ajax({
    type: 'GET',
    url: filteredUrl + '&view=filtered',
    success: function success(content) {
      $('#collection__list--container').remove();
      $('#collection__page--desktop').append(content);
    },
    error: function error(_error) {
      console.log('erreur');
    }
  });
});

$('body').on('click', '.filter__item--mini', function () {
  var filter_value = $(this).attr('filter-value-handle');
  $('.filter__item--mini[filter-value-handle=' + filter_value + ']').remove();
  $('.filter__button[filter-value-handle=' + filter_value + ']')[0].click();
});

$('body').on('click', '.filter__button', function () {
  var mini__filter = window.collection.miniFilter;
  var filter_value = $(this).attr('filter-value-handle'),
      filteredUrl = '';
  var filtersList = window.collection.currentFilters;

  if ($(this).hasClass('is__active')) {
    $('.filter__button[filter-value-handle=' + filter_value + ']').removeClass('is__active');

    filtersList.splice(filtersList.indexOf(filter_value), 1);

    window.collection.currentFilters = filtersList;
    window.collection.currentFilters.sort();

    $('.filter__item--mini[filter-value-handle=' + filter_value + ']').remove();
  } else {
    // Supprime les tags du meme groupe deja actifs
    var group = filter_value.split('_')[0];
    $('.filter__button[filter-group-handle="' + group + '"]').removeClass('is__active');
    $('.filter__item--mini[filter-group-handle="' + group + '"]').remove();
    $('.filter__button[filter-value-handle=' + filter_value + ']').addClass('is__active');
    for (var i = 0; i < filtersList.length; i++) {
      if (filtersList[i].indexOf(group) > -1) {
        filtersList.splice(i, 1);
      }
    }

    window.collection.currentFilters = filtersList;
    window.collection.currentFilters.push(filter_value);
    window.collection.currentFilters.sort();

    $('.filter__values--list').append('<li class="filter__item--mini body__text--footer" filter-value-handle="' + filter_value + '" filter-group-handle="' + group + '"><span>' + $(this).attr('filter-group') + ': ' + $(this).attr('filter-value') + '</span><span class="close close__filter"></span></li>');
  }

  if (window.collection.currentFilters.length > 0) {
    $('.reinitialize__filters').show();
    filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + '/' + window.collection.currentFilters.join('+') + '?sort_by=' + window.collection.sortBy;
  } else {
    $('.reinitialize__filters').hide();
    filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + '?sort_by=' + window.collection.sortBy;
  }

  if (history.replaceState) {
    window.history.pushState({ path: filteredUrl }, '', filteredUrl);
  }

  $.ajax({
    type: 'GET',
    url: filteredUrl + '&view=filtered',
    success: function success(content) {
      $('#collection__list--container').remove();
      $('#collection__page--desktop').append(content);
    },
    error: function error(_error2) {
      console.log('erreur');
    }
  });
});

// mobile
$('.action--button-validate').on('click', function (e) {
  e.preventDefault();
  $('#navigation__drawer--header .close').click();
});
$('.action--button-close').on('click', function (e) {
  e.preventDefault();
  $('#navigation__drawer--header .close').click();
});
'use strict';

// Ouvrir la modal au clic
$('.button__action').on('click', function (e) {
  e.preventDefault();
  var buttonFor = $(this).attr('for');
  var selector = $(this).attr('open-selector');

  console.log('pass here');
  console.log(selector);
  if (selector) {
    console.log("ouverture de la modale");
    $(selector).addClass('opened');
    $('#page__overlay').addClass('opened');
  }

  if (buttonFor == 'modal' && selector) {
    $('#page__overlay').attr('for', 'modal');
  } else if (buttonFor == 'drawer' && selector) {
    $('#page__overlay').attr('for', 'drawer');
  } else if (buttonFor == 'drawer-cart' && selector) {
    $('#page__overlay').attr('for', 'drawer');
    setTimeout(function () {
      $('#drawer__cart--exta-infos').addClass('opened');
    }, 350);
  } else if (buttonFor == 'accordeon') {
    var isActive = false;
    if ($(this).hasClass('active')) {
      isActive = true;
    }
    if ($(this).hasClass('link--item-button')) {
      $('.link--item-button.active').siblings('.accordeon__list').removeClass('opened').slideToggle('500');
      $('.link--item-button.active').children('.plus__icon').removeClass('opened');
      $('.link--item-button.active').removeClass('active');
    } else if ($(this).hasClass('sub__link--item-button')) {
      $('.sub__link--item-button.active').siblings('.accordeon__list').removeClass('opened').slideToggle('500');
      $('.sub__link--item-button.active').children('.plus__icon').removeClass('opened');
      $('.sub__link--item-button.active').removeClass('active');
    }

    if (isActive == false) {
      $(this).toggleClass('active');
      $(this).children('.plus__icon').toggleClass('opened');
      $(this).siblings('.accordeon__list').addClass('opened').slideToggle('500');
    }
  }
  if (buttonFor == 'select' && selector) {
    $('#page__overlay').attr('for', 'select');
  }
});

// Fermer la modal au clic sur la croix
$('.close').on('click', function (e) {
  e.preventDefault();
  var closeFor = $(this).attr('for');

  $('#page__overlay').removeClass('opened');
  $('#page__overlay').attr('for', '');

  if (closeFor == 'modal') {
    $('.modal').removeClass('opened');
    $('.modal-loader').show();
    $('.modal-has-to-load').hide();
  } else if (closeFor == 'drawer') {
    $('.drawer').removeClass('opened');
  } else if (closeFor == 'select') {
    $('.select').removeClass('opened');
  }
});

// Clic en dehors de la'modal'
$('#page__overlay').on('click', function (e) {
  e.preventDefault();
  var overlayFor = $(this).attr('for');

  $(this).removeClass('opened');
  $('#page__overlay').attr('for', '');

  if (overlayFor == 'modal') {
    $('.modal').removeClass('opened');
    $('.modal-loader').show();
    $('.modal-has-to-load').hide();
  } else if (overlayFor == 'drawer') {
    $('.drawer').removeClass('opened');
  } else if (overlayFor == 'select') {
    $('.select').removeClass('opened');
  }
});

// Ajout de la variant lors de la selection + Fermer modal
$('.variant__select').on('click', function (e) {
  //$('#iddeclasse').attr('variant', $(this).attr("value"));
  e.preventDefault();
  $('.select').removeClass('opened');
  var closeFor = $(this).attr('for');
  $('#page__overlay').removeClass('opened');
  $('#page__overlay').attr('for', '');
});

$('#page__overlay--white').on('click', function (e) {
  e.preventDefault();
  $(this).removeClass('opened');
  $('.select__custom--values').hide();
  $('.select__custom--values').removeClass('opened');
});

$('#page__overlay--white-quick-add').on('click', function (e) {
  e.preventDefault();
  $(this).removeClass('opened');
  $('#product-grid-modal .select__custom--values').hide();
  $('#product-grid-modal .select__custom--values').removeClass('opened');
});
'use strict';

document.addEventListener('select-changed:carrier', function (event) {
  var carrierId = $('#carrier__select option:selected').text();
  $('.carrier--container').hide();
  $('.carrier--container[carrierId="' + carrierId + '"]').fadeIn(300).css('display', 'flex');
}, false);
'use strict';

// Clic en dehors de la'modal'
$('#page__overlay').on('click', function (e) {
  e.preventDefault();
  var overlayFor = $(this).attr('for');

  if (overlayFor == 'modal') {
    $('.modal').removeClass('opened');
    $(this).removeClass('opened');
    $('#page__overlay').attr('for', '');
  }
});

// README
// OPEN THE MODAL BUTTON
// <button class="button__action" for="modal" open-selector="#modal-1">Ouvrir</button>
// MODAL
// <div id="modal-1" class="modal" >
//   <span class="close" for="modal"></span>
//   <div>YOUR CONTENT</div>
// </div>

// NOTE
// La modale doit avoir un ID unique que l on va mettre dans open-selector sur le bouton
'use strict';

document.addEventListener('product-grid-modal:open', function (event) {

  $('.modal-has-to-load').hide();

  if (event.detail.productHandle) {
    jQuery.ajax({
      type: 'GET',
      url: '/products/' + event.detail.productHandle + '.js',
      dataType: 'json',
      success: function success(product) {
        window.productGridDetails = product;

        console.log(product);
        var variant;

        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].available == true) {
            variant = product.variants[i];
            break;
          }
        }

        var compareAtprice = variant.compare_at_price;
        var price = variant.price;

        $('#product-grid-modal .product--price').text(displayPrice(price));
        if (compareAtprice > price) {
          var percentagePromo = "- " + Math.floor((parseInt(compareAtprice) - parseInt(price)) / parseInt(compareAtprice) * 100) + "%";
          $('#product-grid-modal .body__text--collection-promo').text(percentagePromo);
          $('#product-grid-modal .sales__tag--container').show();
          $('#product-grid-modal .product--compare-at-price').text(displayPrice(compareAtprice));
        } else {
          $('#product-grid-modal .product--compare-at-price').text("");
          $('#product-grid-modal .sales__tag--container').hide();
        }

        updateProductButtonQuickAdd(variant);

        $('#product-grid-modal .product__title').text(window.productGridDetails.title);
        $('#product-grid-modal .product__brand').text(window.productGridDetails.vendor);
        $('#product-grid-modal .featured--img').attr('src', window.productGridDetails.featured_image);
        $('#product--select').html('');

        for (var j = 1; j <= product.options.length; j++) {
          var liList = "";
          var controlArray = [];
          for (var i = 0; i < product.variants.length; i++) {
            var variant = product.variants[i];
            if (controlArray.indexOf(variant["option" + j]) == -1) {
              liList = liList + ('<li class="select__custom--value ' + (i == 0 ? 'is__active' : '') + '" product-grid="true" value="' + variant["option" + j] + '" for="product__option--' + j + '">' + variant["option" + j] + '</li>');
              controlArray.push(variant["option" + j]);
            }
          }

          var optionList = "";
          for (var i = 0; i < product.variants.length; i++) {
            var variant = product.variants[i];
            optionList = optionList + ('<option value="' + variant["option" + j] + '">' + variant["option" + j] + '</option>');
          }

          $('#product--select').append('<div class="select__custom--container button__action position__relative" >\n            <div class="select__custom--selected-value-container button__action flex flex__direction--row space__between" for="product__option--' + j + '">\n              <span class="margin__horizontal--10 margin__left--none fw--700">\n              ' + product.options[j - 1].name + '\n              </span>\n              <div id="select__custom--' + j + '" class="select__custom--selected-value margin__left--auto" for="select" name="product__option--' + j + '">\n               ' + product.variants[0].options[j - 1] + '\n              </div>\n              <span class="margin__horizontal--20 margin__right--none">\n                <svg class="icon--svg icon--arrow-bottom" role="presentation" viewBox="0 0 21 11">\n                  <polyline fill="none" stroke="currentColor" points="0.5 0.5 10.5 10.5 20.5 0.5" stroke-width="1.25"></polyline>\n                </svg>\n              </span>\n            </div>\n\n            <div class="select__custom--values" for="product__option--' + j + '">\n              <ul>\n                ' + liList + '\n              </ul>\n            </div>\n            <select class="select__hidden" for="product__option--' + j + '">\n              ' + optionList + '\n            </select>\n          </div>');
        }
      }
    });
  }
});

$('.add__to__cart--quick-add').on('click', function () {
  var available = $(this).attr('variant-available');
  if (available == "true") {
    $('#product-grid-modal').removeClass('opened');
    $('#page__overlay').removeClass('opened');
  }
});

var image = $('.featured--img');
image.on('load', function () {
  console.log('image chargée');
  $('.modal-loader').hide();
  $('.modal-has-to-load').fadeIn('300');
});
'use strict';

// Initialisation


// Click sur le select


$('body').on('click', '.select__custom--selected-value-container', function (e) {
  var forSelect = $(this).attr('for');
  $('.select__custom--values[for="' + forSelect + '"]').fadeToggle(50);
  $('.select__custom--values[for="' + forSelect + '"]').addClass('opened');
  $('#page__overlay--white').addClass('opened');
  if ($('#product-grid-modal.opened').length > 0) {
    $('#page__overlay--white-quick-add').addClass('opened');
  }
});

$('body').on('click', '.select__custom--value', function (e) {
  var forSelect = $(this).attr('for');
  var value = $(this).attr('value');
  var valueText = $(this).text();
  //est ce quon a modifie un select via quick view
  var quickAdd = $(this).attr('product-grid') || "false";

  $('.select__custom--value[for="' + forSelect + '"]').removeClass('is__active');
  $(this).addClass('is__active');

  $('.select__custom--selected-value[name="' + forSelect + '"]').text(valueText);
  $('.select__hidden[for="' + forSelect + '"]').val(value).trigger('change');
  $('.select__custom--values').hide();
  $('.select__custom--values').removeClass('opened');
  $('#page__overlay--white').removeClass('opened');
  $('#page__overlay--white-quick-add').removeClass('opened');
  document.dispatchEvent(new CustomEvent('select-changed:' + forSelect, { 'detail': { quickAdd: quickAdd } }));
});

document.addEventListener('select-changed:sort--by', function (elem) {
  console.log('Select has changed');
}, false);

// Sort
Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
$('.select__hidden[for="sort--by"]').bind('change', function () {
  Shopify.queryParams.sort_by = $(this).val();
  location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
});
'use strict';

document.addEventListener('cart_drawer:open', function (elem) {
  $("#cart__drawer").addClass('opened');
  $('#page__overlay').addClass('opened');
  $('#page__overlay').attr('for', 'drawer');
  setTimeout(function () {
    $('#drawer__cart--exta-infos').addClass('opened');
  }, 350);
}, false);

var updateCartButton = function updateCartButton() {
  $.ajax({
    type: 'GET',
    url: '/cart',
    dataType: 'json',
    success: function success(response) {
      var total = response.total_price;
      var empty = response.item_count == 0 ? true : false;
      updateDeliveryModule(total);
      if (empty) {
        $('.cart__drawer--body').addClass('empty__cart');
        $('.cart__total--drawer, .vertical--separator').addClass('display__none');
        $('.empty__cart--drawer').removeClass('display__none');

        if ($('#full__cart--title').length > 0) {
          location.reload(true);
        }
      } else {
        $('.cart__drawer--body').removeClass('empty__cart');
        $('.empty__cart--drawer').addClass('display__none');
        $('.cart__total--drawer, .vertical--separator').removeClass('display__none');
        $('.cart__total--drawer').text(displayPrice(total));

        $('#items--count').text(response.items.length);

        $('.cart__item--total-price').text(displayPrice(total));
        response.items.forEach(function (line_item) {
          var variantId = line_item.variant_id;
          $('.cart__item--container[variant-id=' + variantId + '] .cart__item--total-price').text(displayPrice(line_item.line_price));
        });
      }
    },
    error: function error(_error) {
      console.log('erreur');
    }
  });
};

var updateDeliveryModule = function updateDeliveryModule(total) {
  if (window.cart.deliveryModule) {
    var deliveryLimit = window.cart.freeDelivery - 1;
    var remainPercentage = Math.max(0, (deliveryLimit - total) / deliveryLimit * 100);
    var remainMoney = Math.max(0, (deliveryLimit + 1 - total) / 100);
    var colorBar = 100 - remainPercentage;

    $('#progress__bar--remain').css('width', colorBar + '%');

    if (remainMoney > 0) {
      $('#free__shipping--message').hide();
      $('#remain__shipping__amount--message').show();
      $('.amount__remaining').text(remainMoney + "€");
    } else {
      $('#free__shipping--message').show();
      $('#remain__shipping__amount--message').hide();
    }
  }
};
'use strict';

// Add to cart funnction
if (window.location.pathname == "/cart") {
  window.cart.drawer = false;
}

$('.filter__group--title').on('click', function () {
  $(this).children('.plus__icon').toggleClass('opened');
  $(this).siblings('.filter__group--item-list').slideToggle(300);
  $(this).toggleClass('opened');
});

$('body').on('click', '.add__to__cart', function (e) {
  e.preventDefault();
  var variantId = $(this).attr('variant-id');
  var available = $(this).attr('variant-available');
  var productHandle = $(this).attr('product-handle');
  var variants = $(this).attr('variants');
  var type = $(this).attr('button-type');
  var openModale = $(this).attr('open-selector');

  if (available == 'true' || available == true) {
    if (variants && openModale) {
      document.dispatchEvent(new CustomEvent('product-grid-modal:open', { 'detail': { productHandle: productHandle } }));
    } else if (variantId) {

      var qty = 1;
      if (type == 'product') {
        qty = $('.product__qty--container .quantity__current').val();
      }
      var objUpdate = { quantity: qty, id: variantId };
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: objUpdate,
        dataType: 'json',
        success: function success(response) {
          renderCart();
          updateCartButton();

          if ($('#empty__cart--title').length > 0) {
            location.reload(true);
          }

          if (window.cart.drawer) {
            document.dispatchEvent(new CustomEvent('cart_drawer:open'));
          }
        },
        error: function error(_error) {
          console.log('erreur');
        }
      });
    }
  }
});

$('body').on('click', '.quantity__change--selector', function (e) {
  e.preventDefault();
  var $this = $(this);
  var variantId = $(this).attr('variant-id');
  var variantQty = $(this).attr('variant-qty');
  var type = $(this).attr('type');

  if (variantId) {
    var data = { updates: {} };
    data.updates[variantId] = variantQty;

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function success(response) {
        $('.quantity__current[variant-id="' + variantId + '"]').val(variantQty);
        if (type == 'remove' || variantQty == 0) {
          $('.cart__item--container[variant-id="' + variantId + '"]').remove();
        } else if (type == 'minus' || type == "plus") {
          $('.quantity__change--selector[type="minus"][variant-id="' + variantId + '"]').attr('variant-qty', parseInt(variantQty) - 1);
          $('.quantity__change--selector[type="plus"][variant-id="' + variantId + '"]').attr('variant-qty', parseInt(variantQty) + 1);
        }
        updateCartButton();

        if (window.cart.drawer) {
          document.dispatchEvent(new CustomEvent('cart_drawer:open'));
        }
      },
      error: function error(_error2) {
        console.log('erreur');
      }
    });
  }
});

var renderCart = function renderCart() {
  var url = '/cart?view=sidecart&timestamp=' + Date.now();

  if (window.location.pathname.indexOf('cart') > -1) {
    url = '/cart?view=page&timestamp=' + Date.now();
  }

  $.ajax({
    type: 'GET',
    url: url,
    success: function success(content) {
      var newCart = content;
      $('.cart__items__and__header--container').remove();
      $('.cart__drawer--body').append(newCart);
    },
    error: function error(_error3) {
      console.log('erreur');
    }
  });
};
renderCart = window.renderCart
if (window.cart.drawer == true) {
  renderCart();
}
'use strict';

$(document).on('hover', '.navigation__item--container', function () {
  console.log('hover');
});

var pageOverlayOpened = false;
$(".navigation__item--link-megamenu").mouseenter(function () {
  if (pageOverlayOpened == false) {
    $('#page__overlay--navigation').addClass('opened');
    pageOverlayOpened = true;
  }
});

$(".navigation__item--link-megamenu").mouseleave(function () {
  console.log('quitte le li');
  if (pageOverlayOpened == true) {
    console.log('background black');
    $('#page__overlay--navigation').removeClass('opened');
    pageOverlayOpened = false;
  }
});
'use strict';

var productDetails = {};
if ($('[product-details]').html()) {
  productDetails = JSON.parse($('[product-details]').html());
}

$('.quantity__change--selector-product').on('click', function () {
  var type = $(this).attr('type');
  var currentQty = parseInt($('.product__qty--container .quantity__current').val());

  if (type == 'minus') {
    if (currentQty != 0) {
      $('.product__qty--container .quantity__current').val(currentQty - 1);
    }
  } else {
    $('.product__qty--container .quantity__current').val(currentQty + 1);
  }
});

document.addEventListener('select-changed:product__option--1', function (event) {
  if (event.detail.quickAdd == "true") {
    onOptionChangedQuickAdd();
  } else {
    onOptionChanged();
  }
}, false);
document.addEventListener('select-changed:product__option--2', function (event) {
  if (event.detail.quickAdd == "true") {
    onOptionChangedQuickAdd();
  } else {
    onOptionChanged();
  }
}, false);
document.addEventListener('select-changed:product__option--3', function (event) {
  if (event.detail.quickAdd == "true") {
    onOptionChangedQuickAdd();
  } else {
    onOptionChanged();
  }
}, false);

function updateProductButton(variant, productId) {
  if (variant.availableQty == 0) {
    $('.add__to__cart[product-id="' + productId + '"]').html('<span class="text__center fw--700 tertiary__color main__title--blog-categories ">\n          Rupture de stock - Alerte stock\n        </span>');
    $('.add__to__cart[product-id="' + productId + '"]').attr('id', 'BIS_trigger');
    $('.add__to__cart[product-id="' + productId + '"]').attr('variant-available', false);
    $('.add__to__cart[product-id="' + productId + '"]').attr('data-variant-id', variant.id);
  } else {
    $('.add__to__cart[product-id="' + productId + '"]').html('<span class="text__center fw--700 tertiary__color main__title--blog-categories">Ajouter au panier\n    <span class="padding__horizontal--5">-</span>\n    <span class="product--price">' + variant.price + '</span>');
    $('.add__to__cart[product-id="' + productId + '"]').attr('id', '');
    $('.add__to__cart[product-id="' + productId + '"]').attr('variant-available', true);
  }
}

function onOptionChanged() {
  var productOptions = [];

  for (var i = 1; i <= 3; i++) {
    productOptions[i - 1] = $('.select__custom--selected-value[product-id="' + productDetails.productId + '"][name="product__option--' + i + '"]').text().trim() || "";
  }
  if (productDetails && productDetails.variants.length > 1) {
    productDetails.variants.forEach(function (variant) {
      if (variant.option1 == productOptions[0] && variant.option2 == productOptions[1] && variant.option3 == productOptions[2]) {
        var price = variant.price;
        var compareAtprice = variant.compareAtPrice;

        $('.product--price').text(price);
        $('.product--compare-at-price').text(compareAtprice);

        if (compareAtprice > price) {
          var price = price.replace('€', '');
          var compareAtprice = compareAtprice.replace('€', '');
          var percentagePromo = "- " + Math.floor((parseInt(compareAtprice) - parseInt(price)) / parseInt(compareAtprice) * 100) + "%";
          $('.product__price--container .body__text--collection-promo').text(percentagePromo);
          $('.product__price--container .sales__tag--container').show();
        } else {
          $('.product__price--container .sales__tag--container').hide();
        }

        $('.add__to__cart[product-id="' + productDetails.productId + '"]').attr('variant-id', variant.id);
        var url = document.location.origin + document.location.pathname + ('?variant=' + variant.id);
        window.history.pushState({ path: url }, '', url);
        var featuredImage = variant.imageId;
        var imageNumber = $('#swiper__product .product__image[image-id="' + featuredImage + '"]').attr("slide-number");

        window.sliderProduct.slideTo(imageNumber);
        $('#swiper__product__thumb .swiper-slide').removeClass('active__slide');
        $('#swiper__product__thumb .swiper-slide[image-id="' + featuredImage + '"]').addClass('active__slide');

        updateProductButton(variant, productDetails.productId);
      }
    });
  }
}
'use strict';

function updateProductButtonQuickAdd(variant) {
  $('.add__to__cart--quick-add').attr('variant-id', variant.id);

  if (variant.available == false) {
    $('.add__to__cart--quick-add').html('<span class="text__center fw--700 tertiary__color main__title--blog-categories ">\n          Rupture de stock\n        </span>');
    $('.add__to__cart--quick-add').attr('variant-available', 'false');
  } else {
    $('.add__to__cart--quick-add').html('<span class="text__center fw--700 tertiary__color main__title--blog-categories">Ajouter au panier\n    <span class="padding__horizontal--5">-</span>\n    <span class="product--price">' + displayPrice(variant.price) + '</span>');
    $('.add__to__cart--quick-add').attr('variant-available', 'true');
    $('.add__to__cart--quick-add').attr('id', '');
  }
}

function onOptionChangedQuickAdd() {
  var productOptions = [];

  for (var i = 1; i <= 3; i++) {
    productOptions[i - 1] = $('#product-grid-modal .select__custom--selected-value[name="product__option--' + i + '"]').text().trim() || "";
  }
  if (window.productGridDetails && window.productGridDetails.variants.length > 1) {
    window.productGridDetails.variants.forEach(function (variant) {
      if (variant.option1 == productOptions[0] && (variant.option2 == productOptions[1] || variant.option2 == null) && (variant.option3 == productOptions[2] || variant.option3 == null)) {

        $('#product-grid-modal .featured--img').attr('src', variant.featured_media.preview_image.src);
        $('#product-grid-modal .product--price').text(displayPrice(variant.price));
        if (variant.compare_at_price > variant.price) {
          $('#product-grid-modal .product--compare-at-price').text(displayPrice(variant.compare_at_price));
          var percentagePromo = "- " + Math.floor((parseInt(variant.compare_at_price) - parseInt(variant.price)) / parseInt(variant.compare_at_price) * 100) + "%";
          $('#product-grid-modal .body__text--collection-promo').text(percentagePromo);
          $('#product-grid-modal .sales__tag--container').show();
        } else {
          $('#product-grid-modal .product--compare-at-price').text("");
          $('#product-grid-modal .sales__tag--container').hide();
        }

        updateProductButtonQuickAdd(variant);
      }
    });
  }
}
'use strict';

function init() {
  var imgDefer = document.getElementsByTagName('img');
  for (var i = 0; i < imgDefer.length; i++) {
    if (imgDefer[i].getAttribute('defer-src')) {
      imgDefer[i].setAttribute('src', imgDefer[i].getAttribute('defer-src'));
    }
    if (imgDefer[i].getAttribute('defer-srcset')) {
      imgDefer[i].setAttribute('srcset', imgDefer[i].getAttribute('defer-srcset'));
    }
  }
};

document.addEventListener('shopify:section:load', function (e) {
  init();
});

//footer
$(window).on('resize', function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $('#sidebar-accordion-footer .extended-submenu').hide();
  }
});

$('#search').on('focus', function () {
  window.stopSearchDesktop = true;
  $("#search").val("");
});

$('#search-mobile-drawer').on('focus', function () {
  window.stopSearchMobile = true;
  $("#search-mobile-drawer").val("");
});
'use strict';

var displayPrice = function displayPrice(price) {
  return price / 100 + '€';
};
'use strict';

$('#reset-password').click(function () {
  $('#connexion').css('display', 'none');
  $('#reset').fadeIn("slow");
});
"use strict";